import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as clusterAssignedRecords from '../../../../cluster-assigned-records'
import * as clusterAssignment from '../../cluster-assignment'
import type { Plugin } from '../plugin'

/**
 * Re-fetches functional usage when a cluster is assigned or unassigned,
 * since the record inherits its functional usage from the assigned cluster.
 */
export const loadForCurrentEntityOnClusterAssignmentChange =
  store.effects.create((feature: Plugin['feature'], plugin: Plugin) =>
    rxjs
      .merge(
        ec.models.CollectionProducer.getEc$<clusterAssignedRecords.TypeParams>(
          ec.Name.Predefined.SpaceClusterAssignedRecord,
          { waitUntilReady: true },
        ).pipe(
          rxjs.switchMap(clusterAssignedRecordsEc =>
            clusterAssignedRecordsEc.plugins.editingPlugin.feature.actions.submit.success.observe(),
          ),
        ),
        plugin.collection.plugins
          .lookup(clusterAssignment.Plugin)
          .getWhenReady$()
          .pipe(
            rxjs.switchMap(clusterAssignmentPlugin =>
              clusterAssignmentPlugin.actions.submit.success.observe(),
            ),
          ),
      )
      .pipe(
        rxjs.map(action =>
          feature.actions.loadForCurrentEntity.request.from(action).create(),
        ),
      ),
  )
